<template>
  <div class="wrapper">
    <div class="home">
      <Outcome v-if="sessionFinished" />
      <Landing v-else />
    </div>
  </div>
</template>

<script lang="ts">
import Landing from '@/components/Landing.vue';
import { MetaSourceProxy, useMeta } from 'vue-meta';
import { computed, Ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import Outcome from '@/components/Outcome.vue';

export default {
  name: 'Home',
  components: {
    Outcome,
    Landing,
  },
  setup(): { meta: MetaSourceProxy; sessionFinished: Ref<boolean> } {
    const { t } = useI18n();
    const store = useStore();
    const sessionFinished: Ref<boolean> = computed(() => store.getters['videos/isSessionFinished']);

    const metaInfoTitle = computed(() => t('HOME META'));
    const { meta } = useMeta({
      title: metaInfoTitle.value,
    });

    return {
      meta,
      sessionFinished,
    };
  },
};
</script>

<style lang="scss" scoped>
.home {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
